import { render, staticRenderFns } from "./dispatchReciveOrder.vue?vue&type=template&id=1522759e&scoped=true&"
import script from "./dispatchReciveOrder.vue?vue&type=script&lang=js&"
export * from "./dispatchReciveOrder.vue?vue&type=script&lang=js&"
import style0 from "./dispatchReciveOrder.vue?vue&type=style&index=0&id=1522759e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1522759e",
  null
  
)

export default component.exports